import { render, staticRenderFns } from "./TextTooltip.vue?vue&type=template&id=72df9020&scoped=true&"
import script from "./TextTooltip.vue?vue&type=script&lang=js&"
export * from "./TextTooltip.vue?vue&type=script&lang=js&"
import style0 from "./TextTooltip.vue?vue&type=style&index=0&id=72df9020&prod&scoped=true&lang=css&"
import style1 from "./TextTooltip.vue?vue&type=style&index=1&id=72df9020&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df9020",
  null
  
)

export default component.exports